import styled from 'styled-components'
import 'pretendard/dist/web/static/pretendard.css'
import checkbox_large_checked from 'src/assets/images/nmp/checkbox_large_checked.svg'
import checkbox_large_hover from 'src/assets/images/nmp/checkbox_large_hover.svg'
import checkbox_large_enable from 'src/assets/images/nmp/checkbox_large_enable.svg'
import checkbox_small_checked from 'src/assets/images/nmp/checkbox_small_checked.svg'
import checkbox_small_hover from 'src/assets/images/nmp/checkbox_small_hover.svg'
import checkbox_small_enable from 'src/assets/images/nmp/checkbox_small_enable.svg'
import img_depth1 from 'src/assets/images/nmp/img_depth1.png'
import img_depth2 from 'src/assets/images/nmp/img_depth2.png'
import img_depth3 from 'src/assets/images/nmp/img_depth3.png'
import img_banner from 'src/assets/images/nmp/img_banner.png'
import btn_enable from 'src/assets/images/nmp/btn_enable.png'
import btn_hover from 'src/assets/images/nmp/btn_hover.png'
import btn_pressed from 'src/assets/images/nmp/btn_pressed.png'
import img_kt from 'src/assets/images/nmp/img_kt.png'
import img_lgu from 'src/assets/images/nmp/img_lgu.png'
import img_skt from 'src/assets/images/nmp/img_skt.png'
import { Link } from 'react-router-dom'

const MAX_WIDTH = 1920
const MIN_WIDTH = 1024
const GO_FORM_BTN_WIDTH = 990

const before_contents_y_rate = 0.6
const after_contents_y_rate = 0.3

export const NmpFormStyle = {
  PreloadImages: styled.div`
    position: absolute;
    width: 0;
    height: 0;
    background-image: url(${img_depth1}), url(${img_depth2}), url(${img_depth3}), url(${img_banner}),
      url(${btn_enable}), url(${btn_hover}), url(${btn_pressed}), url(${img_kt}), url(${img_lgu}),
      url(${img_skt}), url(${checkbox_large_checked}), url(${checkbox_large_hover}),
      url(${checkbox_large_enable}), url(${checkbox_small_checked}), url(${checkbox_small_hover}),
      url(${checkbox_small_enable});
  `,

  NmpFormContainer: styled.div`
    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--gradient, linear-gradient(180deg, #16161e 0%, #16161e 100%));
      z-index: -1;
    }
  `,
  HeaderContainer: styled.div`
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 1;
  `,
  HeaderText: styled.span`
    color: var(--white);
    font-family: 'Pretendard', sans-serif;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.44px;
  `,
  HeaderTextHighlight: styled.span`
    font-family: 'Pretendard', sans-serif;
    color: #f32b44;
  `,
  BodyContainer: styled.div<{ $depth: number }>`
    position: relative;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    max-width: 1920px;
    min-width: 1024px;
    height: calc(clamp(${MIN_WIDTH}px, 100vw, ${MAX_WIDTH}px) / 16 * 9);
    background: url(${({ $depth }) =>
        $depth === 1 ? img_depth1 : $depth === 2 ? img_depth2 : img_depth3})
      no-repeat center/cover;
  `,
  BackgroundImg: styled.img`
    width: 100%;
    height: 100%;
  `,
  ContentsContainer: styled.div<{ $depth: number }>`
    position: absolute;
    top: calc(
      clamp(${MIN_WIDTH}px, 100vw, ${MAX_WIDTH}px) / 16 * 9 *
        ${({ $depth }) => ($depth !== 3 ? before_contents_y_rate : after_contents_y_rate)}
    );
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  MoveToFormBtn: styled.button`
    width: calc(clamp(${MIN_WIDTH}px, 100vw, ${MAX_WIDTH}px) * ${GO_FORM_BTN_WIDTH} / ${MAX_WIDTH});
  `,
  MoveToFormBtnImg: styled.img<{ $isActive: boolean }>`
    width: 100%;
    height: 100%;
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
    cursor: ${({ $isActive }) => ($isActive ? 'pointer' : 'default')};
  `,
  MainContentsContainer: styled.div`
    width: 800px;
    height: 550px;
  `,
  BannerImg: styled.img`
    width: 800px;
    height: auto;
  `,
  CertFormContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 30px 50px 15px 50px;
    border-radius: 16px;
    background: var(--white);
  `,
  label: styled.span`
    margin-right: 20px;
    color: #17171f;
    font-family: 'Pretendard', sans-serif;
    font-size: 18px;
    font-weight: 700;
  `,
  AgencyContainer: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    width: 100%;
    height: 56px;
  `,
  AgencyTabs: styled.div`
    display: flex;
    justify-content: space-between;
    height: 100%;
  `,
  AgencyItem: styled(Link)<{ $isActive: boolean; $disabled: boolean; $agency: number }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    height: 100%;
    padding: ${({ $agency }) => ($agency === 0 ? 12 : 16)}px;
    border: 2px solid ${({ $isActive }) => ($isActive ? 'var(--black-100)' : 'var(--black-10)')};
    border-radius: ${({ $agency }) =>
      $agency === 0 ? '10px 0 0 10px' : $agency === 2 ? '0 10px 10px 0' : 0};
    opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    z-index: ${({ $isActive }) => ($isActive ? 1 : 0)};

    &:first-child {
      width: 200px;
    }
    &:not(:first-child) {
      width: 202px;
      margin-left: -2px;
    }
  `,
  AgencyImg: styled.img`
    width: auto;
    height: 100%;
  `,
  PnumberContainer: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    width: 100%;
  `,
  Input: styled.input`
    padding: 6px 8px 6px 20px;
    width: 600px;
    height: 56px;
    min-width: 600px;
    border-radius: 10px;
    background: var(--black-6);
    color: var(--purple-60);
    font-family: 'Pretendard', sans-serif;
    font-size: 20px;
    font-weight: 700;

    &::placeholder {
      color: var(--black-40);
    }
    &:hover {
      background: var(--black-10);
    }
    &:focus {
      border: 2px solid var(--purple-60);
      background: var(--purple-2);
    }
    &:disabled {
      background: var(--black-4);
      color: var(--black-30);
      cursor: not-allowed;
    }
  `,
  NoneLabelContainer: styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
  `,
  CertBtn: styled.button`
    width: 600px;
    height: 56px;
    border-radius: 10px;
    background-color: black;
    color: var(--white);
    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 17px;
    font-weight: 400;
    letter-spacing: -1.7px;

    &:hover {
      background: var(--black-80);
    }
    &:active {
      background: var(--black-70);
    }
  `,
  CertInputContainer: styled.div`
    position: relative;
    width: 600px;
    height: 56px;
  `,
  ResendContainer: styled.div`
    position: absolute;
    top: 0;
    right: 8px;
    display: flex;
    align-items: center;
    height: 56px;
  `,
  Timer: styled.span`
    margin: 0 10px;
    color: var(--black-40);
    font-family: 'Pretendard', sans-serif;
    font-size: 16px;
    font-weight: 500;
  `,
  ResendBtn: styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    border-radius: 10px;
    border: 1px solid var(--purple-8);
    background: var(--white);
    color: var(--purple-60);
    font-family: 'Pretendard', sans-serif;
    font-size: 17px;
    font-weight: 400;

    &:hover {
      background: var(--black-4);
    }
    &:active {
      background: var(--black-10);
    }
  `,
  TermsContainer: styled.div`
    margin: 20px 0;
    width: 600px;
  `,
  TotalTermContainer: styled.div`
    margin-bottom: 16px;
  `,
  TermItemsContainer: styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  `,
  EachTermContainer: styled.div`
    display: flex;
    gap: 6px;
  `,
  TermLabel: styled.label<{ mode: 'all' | 'each' }>`
    display: flex;
    align-items: center;
    gap: ${({ mode }) => (mode === 'all' ? '10px' : 'unset')};
    color: ${({ mode }) => (mode === 'all' ? '#17171f' : 'var(--black-60)')};
    font-family: 'Pretendard', sans-serif;
    font-size: ${({ mode }) => (mode === 'all' ? 16 : 14)}px;
    font-weight: ${({ mode }) => (mode === 'all' ? 700 : 400)};
    cursor: pointer;

    &:hover {
      text-decoration: ${({ mode }) => (mode === 'all' ? 'none' : 'underline')};
    }
  `,
  NoRequiredText: styled.span`
    color: var(--black-30);
    font-family: inherit;
  `,
  TermCheckbox: styled.input.attrs({ type: 'checkbox' })<{ mode: 'all' | 'each' }>`
    position: relative;
    cursor: pointer;
    width: ${({ mode }) => (mode === 'all' ? 28 : 20)}px;
    height: ${({ mode }) => (mode === 'all' ? 28 : 20)}px;
    background: url(${({ mode }) =>
        mode === 'all' ? checkbox_large_enable : checkbox_small_enable})
      no-repeat center/cover;
    transition:
      background 0.3s ease,
      opacity 0.3s ease;

    &:hover {
      background: url(${({ mode }) =>
          mode === 'all' ? checkbox_large_hover : checkbox_small_hover})
        no-repeat center/cover;
    }
    &:checked {
      background: url(${({ mode }) =>
          mode === 'all' ? checkbox_large_checked : checkbox_small_checked})
        no-repeat center/cover;
    }
  `,
  JoinSubmitBtn: styled.button`
    width: 600px;
    height: 56px;
    border-radius: 10px;
    background: var(--gradient_1, linear-gradient(90deg, #8d4cfa 0%, #1e5cdf 100%));
    color: var(--white);
    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 17px;
    font-weight: 400;
    letter-spacing: -1.7px;

    &:hover {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
        linear-gradient(90deg, #8d4cfa 0%, #1e5cdf 100%);
    }
    &:active {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%),
        linear-gradient(90deg, #8d4cfa 0%, #1e5cdf 100%);
    }
  `,
  WarningText: styled.span`
    margin-top: 14px;
    width: 600px;
    color: #da2f31;
    text-align: center;
    font-family: 'Pretendard', sans-serif;
    font-size: 14.5px;
    font-weight: 600;
    letter-spacing: -1.16px;
  `,
  FooterContainer: styled.div`
    margin: 50px;
    text-align: center;
  `,
  FooterText: styled.span`
    color: var(--black-40);
    font-family: 'Pretendard', sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 133.173%; /* 17.312px */
    letter-spacing: -0.65px;
  `,
}
